<template>
  <component
    :is="widget.widgetName"
    :style="style"
  />
</template>

<script>
export default {
  name: 'CustomWidget',
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        justifyContent: this.widget.textAlign,
        alignItems: this.widget.verticalAlign,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
